import { Button, Divider, Form, Select, Skeleton } from 'antd';
import React, { FC, UIEvent, useEffect, useState } from 'react';
import { useLazyGetAdminOrganizationsQuery } from 'app/services/edpApiV1/admins';
import { TOrganizationResponse, TOrganizationResponsePaginated } from 'app/services/edpApiV1/moderator';
import { useAppSelector } from 'app/store';
import { Rule } from 'antd/es/form';
import { useLazyOrganizationsQuery } from 'app/services/edpApiV1/viewer';
import style from '../../index.module.scss';

type TOrganizationsInputProps = {
  onPickAll: (orgs: TOrganizationResponse[]) => void;
  label?: string;
  placeholder?: string;
  rules?: Rule[];
  loading?: boolean;
  isForViewer?: boolean;
};

const OrganizationsInput: FC<TOrganizationsInputProps> = ({
  onPickAll,
  label,
  placeholder,
  rules,
  isForViewer,
  loading,
  ...props
}) => {
  const [getOrganizations, { isLoading, isFetching }] = useLazyGetAdminOrganizationsQuery();
  const [getViewerOrganizations, { isLoading: isLoadingViewer, isFetching: isFetchingViewer }] =
    useLazyOrganizationsQuery();
  const [organizations, setOrganizations] = useState<TOrganizationResponse[]>([]);
  const [organizationsPaginated, setOrganizationsPaginated] = useState<TOrganizationResponse[]>();
  const [page, setPage] = useState(1);
  const [size, setSize] = useState(10);
  const [search, setSearch] = useState('');

  const selectOptions = organizations
    .filter(({ id }) => id != null)
    .map(({ id, name }) => (
      <Select.Option value={id} key={id}>
        {name}
      </Select.Option>
    ));

  useEffect(() => {
    if (isForViewer) {
      if (page === 1) {
        getViewerOrganizations(null)
          .unwrap()
          .then(data => {
            const viewerOrganizations: TOrganizationResponse[] = data.map(({ id, name }) => ({
              id: id + '',
              name: String(name),
              isDemo: false,
            }));
            setOrganizations(viewerOrganizations);
            setOrganizationsPaginated(viewerOrganizations);
          });
      }
      return;
    }
    getOrganizations({ page: page, size: size, search: search })
      .unwrap()
      .then(data => {
        setOrganizations([...organizations, ...(data || [])]);
        setOrganizationsPaginated(data);
      });
  }, [size, page]);

  useEffect(() => {
    if (isForViewer) {
      getViewerOrganizations(null)
        .unwrap()
        .then(data => {
          const viewerOrganizations: TOrganizationResponse[] = data.map(({ id, name }) => ({
            id: id + '',
            name: String(name),
            isDemo: false,
          }));
          setOrganizations(viewerOrganizations);
          setOrganizationsPaginated(viewerOrganizations);
        });
      return;
    }
    getOrganizations({ page: page, size: size, search: search })
      .unwrap()
      .then(data => {
        if (data) {
          setOrganizations(data);
          setOrganizationsPaginated(data);
        }
      });
  }, [search]);

  // const onPopupScroll = (event: UIEvent) => {
  //   const clientHeight = (event.target as HTMLDivElement).clientHeight;
  //   const scrollTop = (event.target as HTMLDivElement).scrollTop;
  //   const scrollHeight = (event.target as HTMLDivElement).scrollHeight;
  //   if (clientHeight + scrollTop >= scrollHeight && page * size < Number(organizationsPaginated?.pagination.total)) {
  //     setPage(oldPage => oldPage + 1);
  //   }
  // };

  return (
    <Form.Item name="organizationIds" label={label} rules={rules}>
      {loading || isLoading || isFetching || isLoadingViewer || isFetchingViewer ? (
        <Skeleton.Input block active />
      ) : (
        <Select
          style={{ width: '100%' }}
          showArrow
          optionFilterProp="children"
          mode="multiple"
          placeholder={placeholder ? placeholder : 'Выберите организации'}
          allowClear
          onSearch={(val: string) => {
            setSearch(val);
          }}
          // onPopupScroll={(event: UIEvent) => onPopupScroll(event)}
          dropdownRender={menu => (
            <>
              {menu}
              <Divider style={{ margin: '4px 0' }} />
              <div className={style.actions}>
                <Button onClick={() => onPickAll(organizations)}>Выбрать все</Button>
              </div>
            </>
          )}
          {...props}
        >
          {selectOptions}
        </Select>
      )}
    </Form.Item>
  );
};

export default OrganizationsInput;
